import { render, staticRenderFns } from "./ModalDoctorXPayment.vue?vue&type=template&id=5d7773ab"
import script from "./ModalDoctorXPayment.vue?vue&type=script&lang=js"
export * from "./ModalDoctorXPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports